// The app's public name and where it lives (docs/NAMING.md). Everything a person reads takes the
// name from here, so a rename is this file plus the TWA manifest and the store listing.
//
// Internal ids keep the code name travel-quest on purpose: the Worker, the D1 database, the Dexie
// database, cookie and storage keys (tq-…), calendar UIDs. Nobody sees them, and renaming them
// would sign every phone out, lose its saved state or duplicate exported events.

export const APP_NAME = 'Roamlings'

/** The publisher on the store listing and in the credits. */
export const STUDIO_NAME = 'Out of Scope Studios'

/**
 * The app's origin once the custom domain is live (A1). Sticky after the first Play upload: the
 * TWA is bound to it by Digital Asset Links, and a phone's sign-in and saved state belong to it.
 */
export const APP_ORIGIN = 'https://roamlings.outofscopestudios.com'

/** The Android package (Bubblewrap applicationId): the app's identity on Play, forever. */
export const ANDROID_PACKAGE = 'com.outofscopestudios.roamlings'
